//Helper function related fo projects
import PropTypes from "prop-types";

export const projectShape = {
  name: PropTypes.string.isRequired,
  address: PropTypes.string,
  town: PropTypes.string,
  link: PropTypes.string,
  category: PropTypes.string,
  region: PropTypes.string.isRequired,
  Latitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  Longitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export const ensureLatAndLng = x => {
  const lat = parseFloat(x.Latitude);
  return Boolean(lat >= -90 && lat <= 90) && Boolean(parseFloat(x.Longitude));
};
export const centerFromProject = project => {
  return [parseFloat(project.Longitude), parseFloat(project.Latitude)];
};



// WEBPACK FOOTER //
// ./src/modules/project.js